import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (!totalPages) return null;

  const pages = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    pages.push(1);
    if (currentPage > 3) pages.push("start-ellipsis");
    for (
      let i = Math.max(2, currentPage - 1);
      i <= Math.min(totalPages - 1, currentPage + 1);
      i++
    ) {
      pages.push(i);
    }
    if (currentPage < totalPages - 2) pages.push("end-ellipsis");
    pages.push(totalPages);
  }

  return (
    <div className="flex gap-2">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`bg-white flex items-center gap-2 text-sm text-[#231F20] border border-[#E4E7EC] px-3 py-1.5 rounded-[50px] active:scale-95 transition-transform duration-100 disabled:opacity-50 disabled:cursor-not-allowed`}
      >
        Previous
      </button>
      <div className="flex gap-1">
        {pages.map((page, idx) => {
          if (page === "start-ellipsis" || page === "end-ellipsis") {
            return (
              <span
                key={page + idx}
                className="px-2 py-1 text-gray-400 select-none"
              >
                ...
              </span>
            );
          }
          return (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                currentPage === page
                  ? "bg-[#6B7143] text-white"
                  : "bg-white border border-[#E4E7EC] text-[#231F20] hover:bg-slate-50"
              }`}
            >
              {page}
            </button>
          );
        })}
      </div>
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`bg-white flex items-center gap-2 text-sm font-medium text-[#231F20] border border-[#E4E7EC] px-3 py-1.5 rounded-[50px] active:scale-95 transition-transform duration-100 disabled:opacity-50 disabled:cursor-not-allowed`}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
